import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'fieldset', 'invertedFieldset'];
  static values = {
    scrollToVisibleFieldset: Boolean,
    clearOnDisable: Boolean,
    hideOnChecked: Boolean,
  };

  // Usage:
  // Add data-action: "change->checkbox-toggled-fieldset#toggle" to the checkbox input
  // Add data-checkbox-toggled-fieldset-target="fieldset" to the fieldset that should be toggled

  connect() {
    this.toggle();
  }

  toggle(event) {
    if (!event && !this.hasCheckboxTarget) return;

    const target = event?.target || this.checkboxTarget;

    const fieldsets =
      this.fieldsetTargets && this.fieldsetTargets.length > 0
        ? this.fieldsetTargets
        : this.fieldsetTarget
        ? [this.fieldsetTarget]
        : [];

    const invertedFieldsets =
      this.invertedFieldsetTargets && this.invertedFieldsetTargets.length > 0
        ? this.invertedFieldsetTargets
        : this.hasInvertedFieldsetTarget
        ? [this.invertedFieldsetTarget]
        : [];

    const shouldHide = this.hideOnCheckedValue
      ? target.checked
      : !target.checked;

    if (shouldHide) {
      fieldsets.forEach((fs) => {
        fs.classList.add('d-none');
        this.disableFormFields(fs, true);
      });
      invertedFieldsets.forEach((fs) => {
        fs.classList.remove('d-none');
        this.disableFormFields(fs, false);
      });
    } else {
      fieldsets.forEach((fs) => {
        fs.classList.remove('d-none');
        this.disableFormFields(fs, false);
      });
      invertedFieldsets.forEach((fs) => {
        fs.classList.add('d-none');
        this.disableFormFields(fs, true);
      });

      if (this.scrollToVisibleFieldsetValue && fieldsets[0]) {
        fieldsets[0].scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  disableFormFields(fieldset, value) {
    Array.from(fieldset.elements).forEach((element) => {
      if (
        element.tagName === 'INPUT' ||
        element.tagName === 'SELECT' ||
        element.tagName === 'TEXTAREA'
      ) {
        element.disabled = value;

        if (value && this.clearOnDisableValue) {
          this.clearElementValue(element);
        }
      }
    });
  }

  clearElementValue(element) {
    const tag = element.tagName;
    const type = element.getAttribute('type');

    if (tag === 'INPUT') {
      if (type === 'checkbox' || type === 'radio') {
        element.checked = false;
      } else {
        element.value = '';
      }
    } else if (tag === 'SELECT') {
      if (element.multiple) {
        Array.from(element.options).forEach((opt) => (opt.selected = false));
      } else {
        element.selectedIndex = -1;
      }
      // Trigger change event so any widgets can react
      const evt = new Event('change', { bubbles: true });
      element.dispatchEvent(evt);
    } else if (tag === 'TEXTAREA') {
      element.value = '';
    }
  }
}
